import React, { useCallback } from 'react';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import PropTypes from 'prop-types';
import styles from './index.css';

const Image = ({ img }) => {
    // 图片类型过滤
    img = img?.map(item => {
        let url = item;
        let isLongImage = false;
        let isGifImgage = false;

        if (url.includes('.gif')) {
            isGifImgage = true;
        }

        url = url.includes('.gif') ? url.replace(/\.webp|_webp/g, '') : formatImage(url, 340, 340);

        const imgReg =
            (url &&
                url.split('/') &&
                url.split('/').pop() &&
                url
                    .split('/')
                    .pop()
                    .split('.') &&
                url
                    .split('/')
                    .pop()
                    .split('.')[0] &&
                url
                    .split('/')
                    .pop()
                    .split('.')[0]
                    .split('_')) ||
            [];

        const imgWidth = (imgReg[1] && imgReg[1].replace('w', '')) || 0;
        const imgHeight = (imgReg[2] && imgReg[2].replace('h', '')) || 0;

        if (imgWidth && imgHeight && (imgWidth / imgHeight < 0.66 || imgWidth / imgHeight > 2)) {
            isLongImage = true;
        }

        return {
            url,
            isLongImage,
            isGifImgage,
            initialUrl: item,
        };
    });

    // 少于3张
    const lessThanThreeImg = wbImages => {
        return (
            <ul className={styles.wbImgBox}>
                <li className={styles.wbImgGroup}>
                    {wbImages.length === 1 && (
                        <div className={`${styles.wbImgItem} ${styles.onlyWbImgItemPic}`}>
                            <img className={styles.wbImgItemPic} src={wbImages[0].url} />
                            {wbImages[0].isLongImage &&
                                !wbImages[0].isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                            {wbImages[0].isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                        </div>
                    )}
                    {wbImages.length === 2 && (
                        <>
                            {wbImages.map((item, index) => (
                                <div key={index} className={styles.wbImgItem}>
                                    <div className={styles.wbImgItemBox}>
                                        <img className={styles.wbImgItemPic} src={item.url} />

                                        {item.isLongImage &&
                                            !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                </div>
                            ))}
                            <div className={styles.wbImgItem} />
                        </>
                    )}
                    {wbImages.length === 3 &&
                        wbImages.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <img className={styles.wbImgItemPic} src={item.url} />

                                    {item.isLongImage &&
                                        !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                </li>
            </ul>
        );
    };

    // 等于4张
    const equalFourImg = wbImages => {
        const imageGroup = [];

        for (let i = 0, len = wbImages.length; i < len; i += 2) {
            imageGroup.push(wbImages.slice(i, i + 2));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                <div className={styles.wbImgItemBox}>
                                    <img className={styles.wbImgItemPic} src={item.url} />
                                    {item.isLongImage &&
                                        !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                        <div className={styles.wbImgItem} />
                    </li>
                ))}
            </ul>
        );
    };

    const greaterThanFiveImg = wbImages => {
        const imageGroup = [];
        const fillIndex = 3 - (wbImages.length % 3);

        for (let j = 0; j < fillIndex; j++) {
            if (fillIndex !== 3) {
                wbImages.push('');
            }
        }
        for (let i = 0, len = wbImages.length; i < len; i += 3) {
            imageGroup.push(wbImages.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div key={index} className={styles.wbImgItem}>
                                {item.url && (
                                    <div className={styles.wbImgItemBox}>
                                        <img className={styles.wbImgItemPic} src={item.url} />
                                        {item.isLongImage &&
                                            !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                )}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    // 大于9张图
    const moreThanNineImg = useCallback(imgs => {
        const originLength = imgs.length;
        const imageGroup = [];

        // 3张图编一组
        for (let i = 0; i < 9; i += 3) {
            imageGroup.push(imgs.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => {
                            return (
                                <div key={index} className={styles.wbImgItem}>
                                    {item.url && (
                                        <div className={styles.wbImgItemBox}>
                                            <img className={styles.wbImgItemPic} src={item.url} />
                                            {item.isLongImage &&
                                                !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                            {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                        </div>
                                    )}
                                    {indexGroup === 2 && index === 2 ? (
                                        <div className={styles.restImgCounts}>+{originLength - 9}</div>
                                    ) : null}
                                </div>
                            );
                        })}
                    </li>
                ))}
            </ul>
        );
    }, []);

    return (
        <div>
            {img?.length > 0 && (
                <div className={styles.shortRelateBox}>
                    {img.length < 4 && lessThanThreeImg(img)}
                    {img.length === 4 && equalFourImg(img)}
                    {img.length > 4 && img.length <= 9 && greaterThanFiveImg(img)}
                    {img.length > 9 && moreThanNineImg(img)}
                </div>
            )}
        </div>
    );
};

Image.propTypes = {
    /**
     * 图片
     */
    img: PropTypes.array,
};

export default Image;
